import React from 'react';
import { Logo } from './Logo.tsx';
import { Terminal, Shield, Menu } from 'lucide-react';

interface HeaderProps {
  onNavigate: (sectionId?: string) => void;
  theme: 'dark' | 'light';
  onToggleTheme: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onNavigate, theme, onToggleTheme }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/40 backdrop-blur-2xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <button 
          onClick={() => onNavigate()}
          className="flex items-center gap-4 group focus:outline-none"
        >
          <Logo className="w-9 h-9 transition-transform duration-500 group-hover:scale-110" />
          <div className="flex flex-col items-start leading-none">
            <span className="text-lg font-black tracking-[0.2em] text-white">
              SAFETOSUBMIT<span className="text-primary text-xs ml-1">.COM</span>
            </span>
            <span className="text-[8px] font-mono font-black text-primary/40 uppercase tracking-[0.4em] mt-1">Forensic Intelligence</span>
          </div>
        </button>
        
        <nav className="hidden md:flex items-center gap-12">
            <button onClick={() => onNavigate('how-it-works')} className="text-[10px] font-mono font-black text-subtext hover:text-primary transition-all uppercase tracking-[0.2em]">SafeScan_Docs</button>
            <button onClick={() => onNavigate('pricing')} className="text-[10px] font-mono font-black text-subtext hover:text-primary transition-all uppercase tracking-[0.2em]">Acquire_Pro</button>
        </nav>
        
        <div className="flex items-center gap-6">
            <div className="hidden sm:flex items-center gap-2 px-4 py-2 border border-white/5 bg-white/5">
                <div className="w-1.5 h-1.5 rounded-full bg-secondary animate-pulse"></div>
                <span className="text-[10px] font-mono font-bold text-secondary uppercase tracking-widest">Global_Status_Green</span>
            </div>
            
            <button 
                onClick={() => onNavigate()}
                className="px-6 py-2.5 text-[10px] font-black text-white bg-white/5 hover:bg-white/10 border border-white/10 transition-all uppercase tracking-[0.2em]"
            >
                Connect_
            </button>
        </div>
      </div>
    </header>
  );
};